import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=4795a373&scoped=true&"
import script from "./ContractsTable.vue?vue&type=script&lang=js&"
export * from "./ContractsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContractsTable.vue?vue&type=style&index=0&id=4795a373&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795a373",
  null
  
)

export default component.exports